module.exports = __webpack_public_path__ + "img/product_37.bad53a4.svg";